import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['ssoType', 'acrValuesField']
  static values = { openidType: String }

  declare readonly ssoTypeTarget: HTMLSelectElement
  declare readonly acrValuesFieldTarget: HTMLElement
  declare readonly openidTypeValue: string

  connect(): void {
    this.toggleAcrValues()
  }

  toggleAcrValues(): void {
    const isOpenid = this.ssoTypeTarget.value === this.openidTypeValue
    this.acrValuesFieldTarget.classList.toggle('sf-hidden', !isOpenid)
  }
}
